import { memo } from 'react';
import * as S from '@/screens/ActivityPage/ui/ActivityPage.styles';
import { NewFeaturedActivities } from '@/shared/FeaturedActivities/ui/NewFeaturedActivities';
import { IRecommendsItem } from '@/shared/FeaturedActivities/ui/featuredActivitiesPreview/FeaturedActivitiesPreview.types';
import { IDestinationList } from '@/entities/Destination/domain/Destination.domain';

type VActivityFeaturedActivitiesProps = {
    recommends: IRecommendsItem[] | null;
    currentDestination: IDestinationList | null;
    title: string;
    isLoading?: boolean;
};

const VActivityFeaturedActivitiesContainer = ({
    recommends = [],
    currentDestination,
    title,
    isLoading = false,
}: VActivityFeaturedActivitiesProps) => {
    if (!recommends?.length) {
        return null;
    }

    const item_list_id = typeof window !== 'undefined' ? window.location.pathname : '';

    return (
        <S.WrapperWithMargin isGiftCard={false}>
            <NewFeaturedActivities
                defaultActivities={recommends}
                title={title}
                subTitle={
                    currentDestination ? `Discover more in ${currentDestination.name}` : undefined
                }
                item_list_id={item_list_id}
                item_list_name={title}
                placeholders={{}}
                isLoading={isLoading}
                isDirectList
            />
        </S.WrapperWithMargin>
    );
};

export const VActivityFeaturedActivities = memo(VActivityFeaturedActivitiesContainer);
